// extracted by mini-css-extract-plugin
export default {"root":"MarketFilter_root__-3vBi","locked":"MarketFilter_locked__YHP13"};